// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { logContextPayloadGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    key: z.string().min(1).max(128),
    payload: logContextPayloadGuard.optional(),
    createdAt: z.number().optional(),
    payloadUserId: z.string().max(128).nullable().optional(),
    payloadApplicationId: z.string().nullable().optional(),
    payloadHookId: z.string().max(21).nullable().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    key: z.string().min(1).max(128),
    payload: logContextPayloadGuard,
    createdAt: z.number(),
    payloadUserId: z.string().max(128).nullable(),
    payloadApplicationId: z.string().nullable(),
    payloadHookId: z.string().max(21).nullable(),
});
export const Logs = Object.freeze({
    table: 'logs',
    tableSingular: 'log',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        key: 'key',
        payload: 'payload',
        createdAt: 'created_at',
        payloadUserId: 'payload_user_id',
        payloadApplicationId: 'payload_application_id',
        payloadHookId: 'payload_hook_id',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'key',
        'payload',
        'createdAt',
        'payloadUserId',
        'payloadApplicationId',
        'payloadHookId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
